export default "__VITE_ASSET__6jh77Uln__"